import { EventEmitter, Injectable, Output, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IAdministrativeComplaintView, IBusinessCitationView, ICorrespondenceView } from 'app/models/mainMenu/mainMenu';
import { IBusinessEnclosedAreasViewModel, IBusinessView } from 'app/models/business/business';
import { IEnclosedAreaEditHistory } from 'app/models/reports/reports';
import { ICorrespondenceLetterTemplate, INewCorrespondenceViewModel } from 'app/models/correspondence/correspondence';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({ providedIn: 'root' })
export class ComplaintService {

  @Output() updateEvent = new EventEmitter<number>();

  currentBusiness: IBusinessView;
  businessList: IBusinessView[] = [];
  businessAdminSearch: string = '';
  userSearch: string = '';
  complaintId: number = 0;
  complaintTab: number = 0;
  complaintVisitTab: number = 0;

  currentComplaint: IAdministrativeComplaintView = {} as IAdministrativeComplaintView;

  public apiComplaint: string = environment.privateApi + 'complaintStaff/';
  public apiCitation: string = environment.privateApi + 'citation/';

  private http = inject(HttpClient);

  updateTabs(tab: number) {
    this.updateEvent.emit(tab);
  }

  // Proccess Complaint 

  getComplaint(id: number): Observable<IAdministrativeComplaintView> {
    return this.http.get<IAdministrativeComplaintView>(this.apiComplaint + 'getComplaint/' + id);
  }

  addComplaintFile(form: FormData): Observable<boolean> {
    return this.http.post<boolean>(this.apiComplaint + 'addComplaintFile', form);
  }

  // Citations

  getCitations(id: number): Observable<IBusinessCitationView[]> {
    return this.http.get<IBusinessCitationView[]>(this.apiCitation + 'getCitations/' + id);
  }

  saveCitation(id: number, notes: IBusinessCitationView): Observable<boolean> {
    return this.http.post<boolean>(this.apiCitation + 'saveCitation/' + id, notes, httpOptions);
  }

  // Enclosed Area

  getEnclosedArea(businessId: number): Observable<IBusinessEnclosedAreasViewModel> {
    return this.http.get<IBusinessEnclosedAreasViewModel>(this.apiComplaint + 'getEnclosedArea/' + businessId);
  }

  reportEnclosedArea(area: IEnclosedAreaEditHistory): Observable<boolean> {
    return this.http.post<boolean>(this.apiComplaint + 'reportEnclosedArea/' , area, httpOptions);
  }

  saveEnclosedArea(area: IEnclosedAreaEditHistory): Observable<boolean> {
    return this.http.post<boolean>(this.apiComplaint + 'saveEnclosedArea/' , area, httpOptions);
  }
  
  addEnclosedAreaDocument(form: FormData): Observable<boolean> {
    return this.http.post<boolean>(this.apiComplaint + 'addEnclosedAreaDocument', form);
  }

  getEnclosedAreaFile(id: number): Observable<Blob> {
    return this.http.get<Blob>(this.apiComplaint + 'getEnclosedAreaFile/' + id, { responseType: 'blob' as 'json' });
  }

  deleteEnclosedAreaFile(businessId: number): Observable<boolean> {
    return this.http.get<boolean>(this.apiComplaint + 'deleteEnclosedAreaFile/' + businessId);
  }

  // Correspondence 

  getCorrespondence(businessId: number, businessOnly: boolean): Observable<ICorrespondenceView[]> {
    return this.http.get<ICorrespondenceView[]>(this.apiComplaint + 'getCorrespondence/' + businessId + '/' + businessOnly);
  }

  addFileCorrespondence(form: FormData): Observable<boolean> {
    return this.http.post<boolean>(this.apiComplaint + 'addFileCorrespondence', form);
  }

  removeAttachment(id: number, typeId: number): Observable<boolean> {
    return this.http.get<boolean>(this.apiComplaint + 'removeAttachment/' + id + '/' + typeId);
  }

  getAttachmentFileName(id: number, typeId: number): Observable<string> {
    return this.http.get(this.apiComplaint + 'getAttachmentFileName/' + id + '/' + typeId, {responseType: 'text'});
  }

  downloadCorrespondenceAttachment(id: number, typeId: number): Observable<Blob> {
    return this.http.get<Blob>(this.apiComplaint + 'downloadCorrespondenceAttachment/' + id + '/' + typeId, 
      { responseType: 'blob' as 'json' });
  }

  getLetterTemplate(id: number, entityId: number, includeBody: boolean,  businessOnly: boolean): 
      Observable<ICorrespondenceLetterTemplate[]> {
    return this.http.get<ICorrespondenceLetterTemplate[]>(this.apiComplaint + 'getLetterTemplate/' + id + '/' + entityId + '/' 
      + includeBody+ '/' + businessOnly);
  }

  saveCorrespondenceLetter(letter: INewCorrespondenceViewModel): Observable<boolean> {
    return this.http.post<boolean>(this.apiComplaint + 'saveCorrespondenceLetter', letter, httpOptions);
  }

  saveCorrespondence(corr: ICorrespondenceView[]): Observable<boolean> {
    return this.http.post<boolean>(this.apiComplaint + 'saveCorrespondence', corr, httpOptions);
  }

}
